import React, { useState, useEffect } from "react";
import { Form, Input, Switch, Button, message } from "antd";

const ClientMessageForm = ({server, token, closeMessageModal}) => {
  const [form] = Form.useForm();
  const [isClosed, setIsClosed] = useState(false);
  const [loading, setLoading] = useState(false);

  // Načtení existujících dat 
  useEffect(() => {
    const fetchData = async () => {

      try {
        const response = await fetch(server + "api2/admin.php", {
            method: "POST",
            body: JSON.stringify({dispatch: 'GET_MESSAGE', token: token}),
        });

        if (!response.ok) {
          throw new Error("Nepodařilo se načíst data");
        }
        const data = await response.json();

        form.setFieldsValue({
          message: data?.message?.message || "",
          closed:   parseInt(data?.message?.closed) === 1
        });
        setIsClosed(data.closed || false);
      } catch (error) {
        message.error(error.message);
      }
    };

    fetchData();
  }, []);

  // Odeslání formuláře
  const handleSubmit = async (values) => {

    setLoading(true);
    try {
        console.log({dispatch: 'SET_MESSAGE', token: token })
        const response = await fetch(server + "api2/admin.php", {
            method: "POST",
            body: JSON.stringify({dispatch: 'SET_MESSAGE', token: token , ...values}),
            
        });
        if (!response.ok) {
            throw new Error("Nepodařilo se uložit data");
        }
        message.success("Zpráva byla úspěšně uložena");
        closeMessageModal()
        } catch (error) {
        message.error(error.message);
        } finally {
        setLoading(false);
        }
  };

  

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        message: "",
        closed: false,
      }}
    >
      <Form.Item
        label="Zpráva pro klienty. Bude zobrazena i když jezdíme"
        name="message"
        rules={[
          {
            message: "Zpráva je povinná",
          },
        ]}
      >
        <Input.TextArea rows={4} placeholder="Zadejte zprávu pro klienty" />
      </Form.Item>
      <Form.Item
        label="Zavřeno"
        name="closed"
        valuePropName="checked"
        >
        <Switch onChange={(value) => setIsClosed(value)}/>
        </Form.Item>
        {isClosed ? (
            <div style={{ marginTop: "16px", color: "red" }}>
                <strong>Obchod je zavřený. Tato zpráva bude zobrazena klientům.</strong>
            </div>
            ) : (
            <div style={{ marginTop: "16px", color: "green" }}>
                <strong>Obchod je otevřený. Klienti mohou objednávat, pokud bude vyplněná zpráva uvidí ji.</strong>
            </div>
        )}
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          style={{ marginTop: "16px" }}
        >
          Odeslat
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ClientMessageForm;
